import styled from 'styled-components';
import '../DesignSystem/ColorTokens.css';
import '../DesignSystem/SpacingTokens.css';
import '../DesignSystem/RadiusTokens.css';

import { device } from '../theme/mediaqueries';

export const TOP_BANNER_HEIGHT = 42;

const Container = styled.main`
  display: flex;
  width: 100%;
  min-height: 100vh;

  --sidebar-width: 250px;
  --site-bottom-padding: 24px;
  --site-top-padding: 0px;

  background: var(--black-200);

  transition: padding-top 150ms cubic-bezier(0.165, 0.84, 0.44, 1);

  @media ${device.md} {
    width: 1280px;
  }

  &.topBanner {
    --site-top-padding: ${TOP_BANNER_HEIGHT}px;
  }

  .mainContent {
    width: 100%;
    padding-top: var(--site-top-padding);
    overflow-x: auto;
  }

  .sidebar {
    --sidebar-background: var(--black-50);
    --sidebar-item-default: var(--black-100);
    --sidebar-item-hover: var(--black-200);
    --sidebar-item-selected: var(--black-300);

    border-right: 1px solid var(--border-color-default);

    background: var(--sidebar-background);
    padding: var(--space-200);

    z-index: 100;
    position: sticky;
    top: var(--site-top-padding);
    left: 0;
    bottom: 0;

    height: calc(100vh - var(--site-top-padding));
    min-width: var(--sidebar-width);
    overflow-y: auto;

    transition: 150ms cubic-bezier(0.165, 0.84, 0.44, 1);

    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.1) transparent;

    @media ${device.md} {
      position: initial;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;

  gap: 24px;
`;

export default { Container, Row };
